import { error } from "console";
import { AuditQuestion } from "../models/AuditQuestion";
import { Audit } from "../models/Audit";
import { AuditDetail } from "../models/AuditDetail";
import { Section } from "../models/Section";
import axios, { AxiosRequestConfig } from "axios";
import { saveAs } from "file-saver";
import { Subsection } from "../models/Subsection";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const insertSubsection = async (subsection: Subsection) => {
  const response = await fetch(`${API_BASE_URL}/Subsection/Insert`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(subsection),
  });

  return response;
};

const updateSubsection = async (subsection: Subsection) => {
  const response = await fetch(`${API_BASE_URL}/Subsection/Update`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(subsection),
  });

  return response;
};

const deleteSubsection = async (subsection: Subsection) => {
  const response = await fetch(`${API_BASE_URL}/Subsection/Delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(subsection),
  });

  return response;
};

const updatePositions = async (
  updates: { subsectionId: number; newPosition: number }[]
) => {
  const response = await fetch(`${API_BASE_URL}/Subsection/UpdatePositions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    throw new Error("Failed to update subsection positions");
  }

  return response;
};

const moveSubsection = async (subsectionId: number, newSectionId: number) => {
  const response = await fetch(`${API_BASE_URL}/Subsection/MoveSubsection`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ subsectionId, newSectionId }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Error al mover la subsección: ${errorText || response.statusText}`
    );
  }

  return response;
};

const SubsectionService = {
  insertSubsection,
  updateSubsection,
  deleteSubsection,
  updatePositions,
  moveSubsection,
};

export default SubsectionService;
